import * as React from "react";
import { Receipt, TransactionHistory } from "../types";
import { getScreenType } from "./utils";
import { currency } from "../utils";
import t from "../i18n";
import { SkuCategory } from "../types-enums";

declare type TrxFailedProps = {
    receipt: Receipt,
    pastTrx: TransactionHistory[];
}
export default class TrxFailed extends React.Component<TrxFailedProps> {
    renderBlockedRefunded() {
        const receipt = this.props.receipt;
        return <div>
            <p dangerouslySetInnerHTML={{
                __html: t.receipt("transactionNotCompleted", {
                    productName: receipt.product.name,
                    internationalCountryCode: receipt.internationalCountryCode,
                    mobileNumber: receipt.mobileNumber,
                    faceValue: currency(receipt.faceValue, receipt.sourceCurrencyCode)
                })
            }} />
            <p>{t.receipt("transactionNoCharge")}</p>
            <p>{t.receipt("checkMobileNumber")}</p>
            <p dangerouslySetInnerHTML={{ __html: t.receipt("supportMessage") }} />
        </div>
    }
    renderErrorGeneric() {
        const receipt = this.props.receipt;
        return <div>
            <p dangerouslySetInnerHTML={{
                __html: t.receipt("transactionNotCompleted", {
                    productName: receipt.product.name,
                    internationalCountryCode: receipt.internationalCountryCode,
                    mobileNumber: receipt.mobileNumber,
                    faceValue: currency(receipt.faceValue, receipt.sourceCurrencyCode)
                })
            }} />
            <p>{t.receipt("transactionNoCharge")}</p>
            <p>{t.receipt("checkMobileNumber")}</p>
            <p dangerouslySetInnerHTML={{ __html: t.receipt("supportMessage") }} />
        </div>
    }
    renderErrorDataPlan() {
        const receipt = this.props.receipt;
        return <div>
            <p dangerouslySetInnerHTML={{
                __html: t.receipt("transactionNotCompleted", {
                    productName: receipt.product.name,
                    internationalCountryCode: receipt.internationalCountryCode,
                    mobileNumber: receipt.mobileNumber,
                    faceValue: currency(receipt.faceValue, receipt.sourceCurrencyCode)
                })
            }} />
            <p>{t.receipt("transactionNoCharge")}</p>
            <p>{t.receipt("dataPlanAlreadyActive")}</p>
            <p dangerouslySetInnerHTML={{ __html: t.receipt("supportMessage") }} />
        </div>
    }
    renderPaymentFailed() {
        const receipt = this.props.receipt;
        return <div>
            <p dangerouslySetInnerHTML={{
                __html: t.receipt("transactionNotCompleted", {
                    productName: receipt.product.name,
                    internationalCountryCode: receipt.internationalCountryCode,
                    mobileNumber: receipt.mobileNumber,
                    faceValue: currency(receipt.faceValue, receipt.sourceCurrencyCode)
                })
            }} />
            <p>{t.receipt("transactionNoCharge")}</p>
            <p dangerouslySetInnerHTML={{ __html: t.receipt("supportMessage") }} />
        </div>
    }
    renderRechargeFailed() {
        return this.renderErrorGeneric();
    }
    renderRechargeInvalidNo() {
        return this.renderErrorGeneric();
    }
    renderRechargeDataPlanFailed() {
        return this.renderErrorDataPlan();
    }
    renderReceipt() {
        const receipt = this.props.receipt;
        const screenType = getScreenType(receipt);
        if (screenType === "blocked-refunded") return this.renderBlockedRefunded();
        if (screenType === "payment-failed") return this.renderPaymentFailed();
        if (screenType === "recharge-failed") return this.renderRechargeFailed();
        if (screenType === "recharge-invalid-no") this.renderRechargeInvalidNo();
        if (screenType === "error-generic") return this.renderErrorGeneric();
        if(screenType === "recharge-failed-data-plan") return this.renderRechargeDataPlanFailed();
        return this.renderErrorGeneric();
    }
    renderErrorGenericGiftCard() {
        const receipt = this.props.receipt;
        return <div>
            <p dangerouslySetInnerHTML={{
                __html: t.receipt("transactionNotCompleted_giftcard", {
                    productName: receipt.product.name,
                    faceValue: currency(receipt.faceValue, receipt.sourceCurrencyCode)
                })
            }} />
            <p>{t.receipt("transactionNoCharge")}</p>
            <p dangerouslySetInnerHTML={{ __html: t.receipt("supportMessage") }} />
        </div>
    }
    renderTopup() {
        return <div style={pageWidth} className="container small-gutter">
            <div className="form-group form-title">
                <h2>{t.topup("balance_failed")}</h2>
            </div>
            {this.renderReceipt()}
        </div>
    }
    renderGiftCard() {
        return <div style={pageWidth} className="container small-gutter">
            <div className="form-group form-title">
                <h2>{t.topup("purchase_failed")}</h2>
            </div>
            {this.renderErrorGenericGiftCard()}
        </div>
    }
    render() {
        if (this.props.receipt.skuCategory == SkuCategory.GiftCard) {
            return this.renderGiftCard();
        }
        else {
            return this.renderTopup();
        }
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}